// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-button-wrapper {
  position: relative;
}
.color-button-wrapper .color-button {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 6px;
  border: none;
  padding: 0;
  cursor: pointer;
}
.color-button-wrapper .color-button:focus {
  outline: revert;
}
.color-button-wrapper .color-button.circle {
  border-radius: 50%;
}
.color-button-wrapper .color-button .checkmark {
  pointer-events: none;
  opacity: 0;
}
.color-button-wrapper .color-button .checkmark.visible {
  opacity: 1;
}
.color-button-wrapper .color-button .checkmark .fill {
  fill: white;
}
.color-button-wrapper .delete-icon-wrapper {
  position: absolute;
  top: -0.25rem;
  right: -0.25rem;
  width: 1.25rem;
  height: 1.25rem;
  background-color: white;
  display: grid;
  place-content: center;
  border-radius: 50%;
  font-size: 0.75rem;
  border: 1px solid rgb(160, 160, 160);
  color: 1px solid rgb(160, 160, 160);
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/ColorPicker/ColorButton.scss","webpack://./src/Components/Global/ColorPicker/Variables.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;AAGE;EACE,aCNc;EDOd,cCPc;EDQd,kBCPiB;EDQjB,YAAA;EACA,UAAA;EACA,eAAA;AADJ;AAGI;EACE,eAAA;AADN;AAII;EACE,kBAAA;AAFN;AAKI;EACE,oBAAA;EACA,UAAA;AAHN;AAKM;EACE,UAAA;AAHR;AAMM;EACE,WAAA;AAJR;AASE;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,mCAAA;EACA,eAAA;AAPJ","sourcesContent":["@import './Variables.scss';\n\n.color-button-wrapper {\n  position: relative;\n\n  .color-button {\n    width: $colorButtonSize;\n    height: $colorButtonSize;\n    border-radius: $buttonBorderRadius;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n\n    &:focus {\n      outline: revert;\n    }\n\n    &.circle {\n      border-radius: 50%;\n    }\n\n    .checkmark {\n      pointer-events: none;\n      opacity: 0;\n\n      &.visible {\n        opacity: 1;\n      }\n\n      .fill {\n        fill: white;\n      }\n    }\n  }\n\n  .delete-icon-wrapper {\n    position: absolute;\n    top: -0.25rem;\n    right: -0.25rem;\n    width: 1.25rem;\n    height: 1.25rem;\n    background-color: white;\n    display: grid;\n    place-content: center;\n    border-radius: 50%;\n    font-size: 0.75rem;\n    border: 1px solid rgb(160, 160, 160);\n    color: 1px solid rgb(160, 160, 160);\n    cursor: pointer;\n  }\n}\n","$colorButtonSize: 2.5rem;\n$buttonBorderRadius: 6px;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
